<template>
  <v-flex
    xs12
    md10
    offset-md1
    align-self-center
    justify-center
  >
    <v-row>
        <v-col
          cols="8"
        >
          <AutoComplete
          :value="searchSchool"
          v-model="searchSchool"
          key-value="id"
          key-name="fullname"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="schools"
          :label="$t('fields.school')"
          @search="searchSchools"
          @input="fetchSchoolsIfExist"
          @clear="deleteSelectedSchools"
          :delay="900"
          :errors="errors"
        >
        </AutoComplete>
        </v-col>
    </v-row>
    <v-card flat light>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :no-data-text="$t('NO_DATA')"
        :no-results-text="$t('NO_DATA')"
        hide-default-footer
        :options.sync="pagination"
        :loading="loading"
        class="elevation-1"
      >

        <template v-slot:[`item.is_primary`]="{ item }">
           <v-icon v-if="item.schools.options && item.schools.options.is_primary">
            done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_suggested`]="{ item }">
           <v-icon v-if="item.adoptions.is_suggested">
            done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>


        <template v-slot:[`item.is_new`]="{ item }">
           <v-icon v-if="item.adoptions.is_new">
            done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_secondary`]="{ item }">
            <v-icon v-if="item.schools.options && item.schools.options.is_secondary">
              done
            </v-icon>
            <v-icon v-else>cancel</v-icon>
        </template>

      </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchReport"
      />
    </v-card>
  </v-flex>
</template>
<script>

import { adoptionsService } from '../../../utils/services/adoptions.service';
import { schoolsService } from '../../../utils/services/schools.service';
import AutoComplete from '../../../components/shared/Inputs/AutoComplete.vue';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AdoptionReportSchool',
  components: { AutoComplete, Paginator },
  data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        searchSchool: null,
        school: {},
        schools: [],
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['isbn'],
        },
        headers: [
          { text: this.$t('fields.isbn'), value: 'books.isbn' },
          { text: this.$t('fields.author'), value: 'books.author' },
          { text: this.$t('fields.title'), value: 'books.title' },
          { text: this.$t('fields.volume'), value: 'books.volume' },
          { text: this.$t('fields.editor'), value: 'editors.name' },
          { text: this.$t('fields.section'), value: 'adoptions.section' },
          { text: this.$t('fields.is_new'), value: 'is_new' },
          { text: this.$t('fields.is_secondary'), value: 'is_secondary' },
          { text: this.$t('fields.is_primary'), value: 'is_primary' },
          { text: this.$t('fields.is_suggested'), value: 'is_suggested' },
          { text: this.$t('fields.pubblication_year'), value: 'books.pubblication_year' },
          { text: this.$t('fields.school'), value: 'schools.name' },
        ],
        filters: {
          schoolId: null,
          searchSchool: null,
        },
      };
    },

    computed: {
      requestFilters() {
        const filters = {
          schoolId: this.filters.schoolId,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },

    methods: {

      deleteSelectedSchools() {
        this.school = {};
        this.filters.schoolId = null;
      },

      async searchSchools(val) {
        this.filters.searchSchool = val;
        await this.fetchSchools();
      },

      async fetchSchoolsIfExist(id) {
        if (id > 0) {
          this.filters.schoolId = id;
          await this.fetchSchool(id);
        } else {
          this.filters.schoolId = 0;
        }
      },

      async fetchSchools() {
        this.loading = true;
        return schoolsService.index({
          filters: {
            search: this.filters.searchSchool,
          },
        })
        .then(response => {
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchSchool(id) {
        this.loading = true;
        return schoolsService.get(id)
        .then(response => {
            this.school = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchReport(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return adoptionsService.reportSchool({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        },
          )
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
              this.handleError(error, this.errors);
          }).finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      this.fetchReport(1);
    },
    watch: {
      'filters.schoolId': {
        handler() {
          this.fetchReport(1);
        },
      },
    },
};
</script>
